import { Card, List, ListItem, ListItemText } from "@material-ui/core";
import locale from "@bonliva-crm/locale";

type Props = {
  onCreateOpportunity: () => void;
  onCreatePresentation: () => void;
};

export function CreatePresentationMenu(props: Props) {
  return (
    <Card style={{ padding: 0 }}>
      <List>
        <ListItem button onClick={props.onCreateOpportunity}>
          <ListItemText primary={locale.ForPipeline} />
        </ListItem>

        <ListItem button onClick={props.onCreatePresentation}>
          <ListItemText primary={locale.ToCustomer} />
        </ListItem>
      </List>
    </Card>
  );
}
